// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-76f9315b] {\n  fill: #fff\n}\n.st3[data-v-76f9315b] {\n  fill: #f0a53c\n}\n.st10[data-v-76f9315b] {\n  fill: #ff7f00\n}\n.st11[data-v-76f9315b] {\n  fill: #ff4900\n}\n", ""]);
// Exports
module.exports = exports;
